import { VisualEventsGroup } from 'src/pages/visual-events/data/types/VisualEvents';
import { createController, createControllerEndpoint } from '../utils/api'
import { useGlobalProject } from 'src/utils/globals';

const project = useGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/visual-events/' + project.UniqueCode, {
    getVisualEventsGroup: createControllerEndpoint<VisualEventsGroup>('GET', '/{id}'),
    getAllVisualEventsGroups: createControllerEndpoint<Array<VisualEventsGroup>>('GET', '/'),
    getById: createControllerEndpoint<VisualEventsGroup>('GET', '/{id}'),

    createVisualEventsGroup: createControllerEndpoint<{ id: number }>('POST', '/'),
    deleteVisualEventsGroup: createControllerEndpoint<void>('DELETE', '/{id}'),

    saveDescriptor: createControllerEndpoint<void>('PUT', '/{id}'),
    saveMeta: createControllerEndpoint<void>('PUT', '/{id}/meta'),

    turnOn: createControllerEndpoint<void>('POST', '/{id}/activation'),
    turnOff: createControllerEndpoint<void>('DELETE', '/{id}/activation')
});
